import {useQuery} from "@tanstack/react-query";
import {useEffect} from "react";
import {getMyPermissions} from "../services/AccountService";
import {useLogout} from "./useLogout";

// Effective permission claims of the signed-in admin (GET /api/v3/auth/me/permissions, TMMFX-3571).
// Returns the flat array of claim values; empty until loaded.
export function useMyPermissions(enabled = true) {
    const logout = useLogout();
    const {data, isError, error} = useQuery({
        queryKey: ["myPermissions"],
        queryFn: getMyPermissions,
        enabled,
        retry: false,
    });

    useEffect(() => {
        if (isError && error?.response?.status === 401) {
            logout();
        }
    }, [isError, error]);

    return data ?? [];
}
